import { Directive, HostListener } from '@angular/core';
import { AuthorizationService } from 'src/app/services/authorization/authorization.service';

@Directive({
    selector: '[appStayingAlive]'
})
export class StayingAliveDirective
{
    private authService: AuthorizationService;

    public constructor(
        authorizationService: AuthorizationService
    )
    {
        this.authService = authorizationService;
    }

    @HostListener('click') public onClick(): void
    {
        this.authService.hasBeenUIActive();
    }
}
